module.exports = __webpack_public_path__ + "img/select-check.89cec218.svg";